// Components
const ClientHeader = () => import(/* webpackPrefetch: true, webpackChunkName: "client-header" */ '@/app/views/client-view/_shared/client-header/client-header.vue');
const TheFooter = () => import(/* webpackPrefetch: true, webpackChunkName: "the-footer" */ '@/app/views/main-view/_shared/the-footer/the-footer.vue');
const DoggyPacksListPage = () => import(/* webpackPrefetch: true, webpackChunkName: "doggy-packs-list-page" */ '@/app/views/client-view/doggy-pack-page/components/doggy-packs-list-page/doggy-packs-list-page.vue');

// Mixins
import { googleTagManagerMixins } from '@/app/mixins/utils/google-tag-manager-mixins';

export default {
    name: 'DoggyPackListContainer',
    mixins: [googleTagManagerMixins],
    components: {
        ClientHeader,
        TheFooter,
        DoggyPacksListPage,

    },
    computed: {
        isNativeApp() {
            return this.$store.getters.getIsNativeApp;
        },
    },
    data() {
        return {
            hasLatitudePay: false,
            showMainLogo: true
        };
    },
}